import { useMutation } from "@tanstack/react-query";
import { CREATE_GOAL } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseData } from "api/types";
import { IReturnType } from "hooks/types";
import { SnackbarSeverity } from "hooks/useSnackbar";
import IGoal from "models/Goal";

type Props = {
  callback?: () => void;
  showSnackbar?: (message: string, severity: SnackbarSeverity) => void;
};

const useCreateGoalMutation = ({ callback, showSnackbar }: Props) => {
  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
    mutate,
  }: IReturnType<ApiResponseData<IGoal>> = useMutation(
    [CREATE_GOAL],
    (newGoal) => {
      return fetchApi(`kpis`).post(`kpis`, newGoal);
    },
    {
      onSuccess: (data) => {
        showSnackbar && showSnackbar("Goal Created Successfully", "success");
        callback && callback();
      },
      onError: (error) => {
        showSnackbar("Failed to Create New Goal", "error");
      },
    }
  );

  return { data: response?.data, isLoading, isError, isFetching, isSuccess, mutate, refetch };
};

export default useCreateGoalMutation;
